module.exports = __webpack_public_path__ + "static/media/banner-snappy.7cbe2fe9.png";